import { Text, Pill } from "components/commons";
import { dateFormat, formatAmount, timeFormat } from "utils";
import styles from "./shift-records.module.scss";
import { locale } from "localization/en";
import { FormMode, Path, ShiftStatus } from "enums";
import { prettifyShiftStatus } from "utils/pretty.utils";
import classNames from "classnames";
import ValidatedPopOverMenu from "./shift-records-menu";

export const initializePumpTotals = ({ currentShift, recentShift, pageMode }) => {
  let totals = [];

  const currentShiftPumpTotals = currentShift?.shiftPumpTotals;
  const MAX = "999999999999999.999";

  const isReopen =
    !!currentShift?.shift?.closedAt && currentShift?.shift?.status === ShiftStatus.Ended;

  currentShiftPumpTotals.forEach((currentPump) => {
    if (currentPump.fuelingPointId === "Pump 02") {
      return;
    }

    const recentShiftPump = recentShift?.shiftPumpTotals?.find(
      (pump) => pump.fuelingPointId === currentPump.fuelingPointId,
    );

    Object.keys(currentPump).forEach((key) => {
      if (currentPump[key] < 0) {
        currentPump[key] = "0.000";
        return;
      }

      if (currentShift.shift.status === ShiftStatus.Closed || isReopen) {
        if (key.toLowerCase().includes("start") && !key.toLowerCase().includes("old")) {
          const startValue = String(currentPump[key]);
          currentPump[key] =
            startValue === "1000000000000000" ? MAX : currentPump[key] === 0 ? "0.000" : startValue;
        }

        if (key.toLowerCase().includes("end") && !key.toLowerCase().includes("old")) {
          const endValue = String(currentPump[key.replace("start", "end")]);
          currentPump[key] =
            endValue === "1000000000000000" ? MAX : currentPump[key] === 0 ? "0.000" : endValue;
        }
      } else {
        if (key.toLowerCase().includes("start") && !key.toLowerCase().includes("old")) {
          const isNull = currentPump[key] === null;
          if (isNull) {
            currentPump[key] = "";
            return;
          }

          if (recentShift) {
            if (recentShiftPump) {
              const endingTotalizer = recentShiftPump[key.replace("start", "end")];
              const startValue = String(endingTotalizer);

              currentPump[key] =
                startValue === "1000000000000000"
                  ? MAX
                  : endingTotalizer === 0 || endingTotalizer === "0"
                    ? "0.000"
                    : startValue;
            } else {
              const startValue = String(currentPump[key]);
              currentPump[key] =
                startValue === "1000000000000000"
                  ? MAX
                  : startValue === 0 || startValue === "0"
                    ? "0.000"
                    : startValue;
            }
          } else {
            currentPump[key] = currentShift?.station?.isConnectedToPts
              ? currentPump[key] === "1000000000000000"
                ? MAX
                : currentPump[key] === 0
                  ? "0.000"
                  : currentPump[key]
              : "0.000";
          }
        }

        if (key.toLowerCase().includes("end") && !key.toLowerCase().includes("old")) {
          const endingTotalizer = currentPump[key];
          const isNull = endingTotalizer === null;
          if (isNull) {
            currentPump[key] = "";
            return;
          }

          currentPump[key] =
            endingTotalizer === "1000000000000000"
              ? MAX
              : endingTotalizer === 0
                ? "0.000"
                : endingTotalizer;
        }
      }
    });

    totals.push(currentPump);
  });

  totals = totals.map((pump) => {
    const keysToDelete = [];

    Object.keys(pump).forEach((key) => {
      if (key.toLowerCase().includes("start") && !key.toLowerCase().includes("old")) {
        const productCode = key.replace("startTotalizer", "").toLowerCase();
        const transactions = currentShift.transactionItem?.[`${productCode}Transactions`];

        const isProductAvailable =
          transactions?.length > 0
            ? true
            : isProductExistInUGT(productCode, currentShift.station.stationUgt);

        if (!isProductAvailable) {
          keysToDelete.push(key);
        }
      }

      if (key.toLowerCase().includes("end") && !key.toLowerCase().includes("old")) {
        const productCode = key.replace("endTotalizer", "").toLowerCase();
        const transactions = currentShift.transactionItem?.[`${productCode}Transactions`];

        const isProductAvailable =
          transactions?.length > 0
            ? true
            : isProductExistInUGT(productCode, currentShift.station.stationUgt);

        if (!isProductAvailable) {
          keysToDelete.push(key);
        }
      }
    });

    keysToDelete.forEach((key) => delete pump[key]);

    return pump;
  });

  return totals;
};

export const isProductExistInUGT = (productCode, stationUgt = []) => {
  return stationUgt.some((ugt) => ugt.productCode === productCode);
};

export const getShiftPumpTotals = (currentShift) => {
  return (currentShift?.shiftPumpTotals || [])
    .filter((pump) => pump.fuelingPointId !== "Pump 02")
    .map((pump) => {
      const pumpCopy = { ...pump };

      Object.keys(pumpCopy).forEach((key) => {
        if (key.toLowerCase().includes("start") && !key.toLowerCase().includes("old")) {
          const productCode = key.replace("startTotalizer", "").toLowerCase();

          const isExist = isProductExistInUGT(productCode, currentShift.station.stationUgt);
          if (!isExist) {
            delete pumpCopy[key];
            delete pumpCopy[key.replace("start", "end")];
            delete pumpCopy[`${key.replace("startTotalizer", "remarks")}`];
          }
        }
      });

      return pumpCopy;
    });
};

// export const initializePumpTotals = ({ currentShift }) => {
//   let totals = [];
//   const shiftPumpTotals = getShiftPumpTotals(currentShift);

//   shiftPumpTotals.forEach((pump) => {
//     if (pump.fuelingPointId === "Pump 02") {
//       return;
//     }

//     const isExist = totals.findIndex((total) => total.shiftPumpTotalId === pump.shiftPumpTotalId);
//     const MAX = "999999999999999.999";

//     Object.keys(pump).forEach((key) => {
//       if (key.toLowerCase().includes("start") && !key.toLowerCase().includes("old")) {
//         pump[key] =
//           currentShift.shift.status === ShiftStatus.Closed
//             ? pump[key]
//             : pump[key.replace("start", "end")];
//       }

//       if (
//         (key.toLowerCase().includes("start") || key.toLowerCase().includes("end")) &&
//         !key.toLowerCase().includes("old")
//       ) {
//         if (pump[key] === null) {
//           return;
//         }

//         const totalizerValue = String(pump[key]);
//         pump[key] = totalizerValue === "1000000000000000" ? MAX : totalizerValue;
//       }
//     });

//     if (isExist >= 0) {
//       totals[isExist] = {
//         ...totals[isExist],
//         ...pump,
//       };
//     } else {
//       totals.push(pump);
//     }
//   });

//   totals = totals.map((pump) => {
//     Object.keys(pump).forEach((key) => {
//       if (key.toLowerCase().includes("start") && !key.toLowerCase().includes("old")) {
//         pump[key] =
//           (currentShift?.shift?.status === ShiftStatus.Closed || currentShift?.recentShift) &&
//           pump[key] !== null
//             ? pump[key] || "0.000"
//             : "";
//       }

//       if (key.toLowerCase().includes("end") && !key.toLowerCase().includes("old")) {
//         pump[key] = currentShift?.shift?.status === ShiftStatus.Closed ? pump[key] || "0.000" : "";
//       }
//     });

//     return pump;
//   });

//   return totals;
// };

export const mapDataToList = ({
  shifts,
  history,
  showPrevModal,
  showSyncModal,
  showReopenModal,
}) => {
  const {
    startShift,
    endShift,
    shiftNumber,
    status,
    employees,
    totalBosTransactionCount,
    shiftId,
    totalTransactionCount,
    totalSales,
    totalAdjustments,
    isRecentClosedShift,
  } = shifts;

  const transactionCount = totalBosTransactionCount || 0;
  let syncPercentage = calculateSyncProgress({
    totalBosTransactionCount,
    totalTransactionCount,
  });

  let syncStatus = "pending";
  if (syncPercentage === 100) {
    syncStatus = "done";
  } else if (syncPercentage > 100 && syncPercentage < 0) {
    syncStatus = "ongoing";
  }

  let cashier = "--";
  if (employees && employees.length > 0) {
    const copyEmployee = [...employees];
    copyEmployee.sort((a, b) => {
      return b.shiftEmployeeId - a.shiftEmployeeId;
    });
    cashier = copyEmployee[employees.length - 1].name;
  }

  const options = [
    {
      content: locale.viewDetails,
      onClick: () => {
        history.push(Path.ViewShiftDetailsInfoById(shiftId, FormMode.View));
      },
    },
  ];
  if (status === ShiftStatus.Ended && syncPercentage === 100) {
    options.push({
      content: locale.editDetails,
      onClick: () => {
        history.push(Path.ViewShiftDetailsInfoById(shiftId, FormMode.Edit));
      },
    });
  }

  return {
    startShift: (
      <>
        <Text className={styles.td}>{dateFormat(startShift ?? "")}</Text>
        <Text className={styles.td}>{timeFormat(startShift ?? "")}</Text>
      </>
    ),
    endShift: (
      <>
        <Text className={styles.td}>{endShift != null ? dateFormat(endShift) : "--"}</Text>
        <Text className={styles.td}>{endShift != null ? timeFormat(endShift) : ""}</Text>
      </>
    ),
    shiftNumber: (
      <>
        <Text className={styles.td}>
          {status === ShiftStatus.Started ? locale.currentShift : (shiftNumber ?? "--")}
        </Text>
      </>
    ),
    cashier: (
      <>
        <Text className={styles.td}>{cashier}</Text>
      </>
    ),
    totalSales: (
      <>
        <Text className={styles.td}>{formatAmount(totalSales ?? 0)}</Text>
      </>
    ),
    adjustmentTotal: (
      <>
        <Text className={styles.td}>
          {formatAmount(
            totalAdjustments ?? 0,
            undefined,
            undefined,
            undefined,
            totalAdjustments < 0,
          )}
        </Text>
      </>
    ),
    shiftStatus: (
      <Pill
        className={styles.status}
        cheddar={status === ShiftStatus.Ended}
        grass={status === ShiftStatus.Started}
        cement={status === ShiftStatus.Closed}
      >
        {prettifyShiftStatus(status)}
      </Pill>
    ),
    syncProgress: (
      <div className={styles.sync}>
        <Text className={classNames(styles.percentage, styles[syncStatus])}>
          {status !== ShiftStatus.Started && `${syncPercentage} %`}
          {status === ShiftStatus.Started ? (
            <span className={styles.content}>{`(${transactionCount})`}</span>
          ) : (
            <span
              className={styles.content}
            >{`(${transactionCount}/${totalTransactionCount})`}</span>
          )}
        </Text>
      </div>
    ),
    actions: (
      <ValidatedPopOverMenu
        shifts={shifts}
        history={history}
        syncPercentage={syncPercentage}
        showPrevModal={showPrevModal}
        showSyncModal={showSyncModal}
        showReopenModal={showReopenModal}
        isRecentClosedShift={isRecentClosedShift}
      />
    ),
  };
};

export const mapFilterToRequest = (filterState) => {
  const { statuses, cashiers, ...fs } = filterState;
  let newCashiers;
  if (cashiers.value.length && !cashiers.isAll) {
    newCashiers = cashiers.value
      .map(({ value }) => {
        return value;
      })
      .join(",");
  } else {
    newCashiers = null;
  }

  return {
    ...fs,
    cashiers: newCashiers,
    statuses: !statuses.isSelectedAll ? statuses.value.join(",") : null,
  };
};

export const calculateSyncProgress = ({
  totalTransactionCount = 0,
  totalBosTransactionCount = 0,
}) => {
  if (Number(totalTransactionCount) === 0 && Number(totalBosTransactionCount) === 0) {
    return 100;
  }

  const syncPercentage =
    totalTransactionCount > 0 ? (totalBosTransactionCount / totalTransactionCount) * 100 : 0;

  return Math.round(syncPercentage * 100) / 100;
};
